import { configureStore } from '@reduxjs/toolkit';
import checkpointsReducer from '../features/checkpoints/checkpointsSlice';

export default configureStore({
  reducer: {
    checkpoints: checkpointsReducer
  },
});
